import { type PivotChartSpecPipeline, type VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  xBand,
  yLinear,
  initArea,
  lineAreaAnimation,
  stackInverse,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  datasetPivot,
  pivotIndicators,
  pivotDiscreteLegend,
  pivotAdapter,
  initPivot,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotColumnDimensions,
  pivotRowDimensions,
  annotationPoint,
  annotationDifferenceLine,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  pointStyle,
  lineStyle,
  areaStyle,
  verticalCrosshairLine,
  pointStateDimensionHover,
  datasetXY,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  colorPointStyleFill,
  colorLineStyleFill,
  colorAreaStyleFill,
  pivotColorLegend,
  pivotAxisStyle,
  pivotTitle,
  splitLine,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
  regionPadding,
} from '../pipes'

const area: VChartSpecPipeline = [
  fontFamilyTheme,
  initArea,
  lineAreaAnimation,
  regionPadding,
  stackInverse,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetXY,
  animationMorph,
  progressive,
  xBand,
  yLinear,
  label,
  brush,
  tooltip({ titleEncoding: 'x' }),
  colorAdapter(discreteLegend, colorLegend),
  verticalCrosshairLine,
  colorPointStyleFill(pointStyle),
  pointStateDimensionHover,
  colorLineStyleFill(lineStyle),
  colorAreaStyleFill(areaStyle),
  annotationPoint,
  annotationDifferenceLine,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  splitLine,
]

const pivotArea: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initArea,
    lineAreaAnimation,
    regionPadding,
    colorAdapter(color, linearColor),
    backgroundColor,
    stackInverse,
    datasetXY,
    animationMorph,
    progressive,
    xBand,
    pivotAxisStyle(yLinear),
    label,
    brush,
    tooltip({ titleEncoding: 'x' as const }),
    verticalCrosshairLine,
    colorPointStyleFill(pointStyle),
    pointStateDimensionHover,
    colorLineStyleFill(lineStyle),
    colorAreaStyleFill(areaStyle),
    annotationPoint,
    annotationDifferenceLine,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationArea,
    splitLine,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const areaSpecPipeline = [pivotAdapter(area, pivotArea)]
